import { render, staticRenderFns } from "./trilhasinfo.vue?vue&type=template&id=27e48501"
import script from "./trilhasinfo.vue?vue&type=script&lang=js"
export * from "./trilhasinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports